import { parseAmount } from "@/lib/misc/parseAmount";
import { RootState } from "@/lib/redux/types";
import { Amount } from "@evergiving/common/dist/es2015/pledge";

// FIXME: this will trigger too many re-renders for custom amounts because of
// equality
export const amountSelector = (state: RootState): Amount => {
  // The pledge's own amount outranks anything the campaign configures: this
  // form is paying a pledge that already exists. The authorization can only
  // come from a pledge link, so no further check is possible here.
  if (state.formPledgePaymentAuthorization) {
    return state.formPledgePaymentAuthorization.authorization.amount;
  }

  if (state.presetAmount) {
    return state.presetAmount;
  }

  if (state.customCurrency && state.customAmountString.value) {
    const value = parseAmount(state.customAmountString.value);

    if (typeof value !== "undefined") {
      return {
        currency: state.customCurrency,
        value,
      };
    }
  }

  return { currency: "XXX", value: 0 };
};
